<template>
    <div>
      <ClosureSummary/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import ClosureSummary from '@/components/ClosureSummary.vue'
  
  export default {
    name: 'closure-summary-view',
    components: {
      ClosureSummary
    }
  }
  </script>
  